export default "__VITE_ASSET__CrSAFOIp__"